/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Edit_Marker_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Marker" |
*
* @param {Markers_Edit_Marker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_edit_marker_title = /** @type {((inputs?: Markers_Edit_Marker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Edit_Marker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitungsmarkierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcador de edição")
	return /** @type {LocalizedString} */ ("Edit Marker")
});